<template>
  <div class="flex w-full flex-col" data-cy="recent-note">
    <div class="flex cursor-pointer items-center space-x-1" @click="openNotes">
      <icon-base :icon="IconNotes" class="flex-none text-disabled-medium" />
      <markdown-text
        v-if="model.latest_note?.comment"
        v-tooltipable
        class="line-clamp-2 truncate whitespace-nowrap text-headline hover:underline"
        data-cy="note"
        :content="model.latest_note?.comment"
      />
      <span v-else>-</span>
    </div>
    <date-and-time-display
      v-if="model?.latest_note?.updated_at"
      :value="model.latest_note.updated_at"
      :show-time-below-date="false"
    />
  </div>
</template>

<script setup lang="ts">
import { DealActivityState } from "@/enums/dealActivity";
import { PipType } from "@/enums/pip";
import { DEFAULT_DEAL_ACTIVITY_OPTIONS } from "@/helpers/constants/deals";
import { useEmitter } from "@/hooks/common";
import { useLocalStorageSetting } from "@/hooks/options";
import { usePiPView } from "@/hooks/pip";
import useNotesStore from "@/stores/notes";

import IconNotes from "@/components/icons/IconNotes.vue";
import IconBase from "@/components/ui/IconBase.vue";
import DateAndTimeDisplay from "@/components/ui/text/DateAndTimeDisplay.vue";
import MarkdownText from "@/components/ui/text/MarkdownText.vue";

import type { Note } from "@/models/notes";

interface Props {
  model: { latest_note?: Note; id?: string };
}

const { model } = defineProps<Props>();

const notesStore = useNotesStore();
const dealActivityOptions = useLocalStorageSetting(
  "dealActivityOptions",
  DEFAULT_DEAL_ACTIVITY_OPTIONS
);
const { isPiPAvailable } = usePiPView();
const emitter = useEmitter();

const openNotes = () => {
  if (!model.id) {
    return;
  }
  notesStore.activeNoteDealId = model.id;

  if (isPiPAvailable.value && dealActivityOptions.value.isPiPModeEnabled) {
    dealActivityOptions.value = {
      ...dealActivityOptions.value,
      state: DealActivityState.PiP,
    };
    emitter.emit("OPEN_PIP_VIEW", PipType.DealActivity);
    emitter.emit("UPDATE_PIP_DEAL", { setCurrentDeal: false });
    return;
  }

  dealActivityOptions.value = {
    ...dealActivityOptions.value,
    state: DealActivityState.Draggable,
  };
};
</script>
